(function(){
  'use strict';
  var FILL='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var OUTLINE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var CARD_SELECTOR='.js-product-image, [class*="ai-new-arrivals-image-wrapper"]';
  var wishlistedSet={};

  function injectHeaderHeart(){
    var lists=document.querySelectorAll('.shopping__cart-links');
    for(var i=0;i<lists.length;i++){
      var ul=lists[i]; if(ul.querySelector('.gp-wishlist')) continue;
      var seeks=ul.querySelector('.seeks');
      var li=document.createElement('li'); li.className='cart-links__link-wishlist gp-wishlist';
      li.innerHTML='<a href="/pages/wishlist" class="gp-wishlist__link" aria-label="Wishlist">'+OUTLINE+'<span class="gp-wishlist__count" data-swym-count style="display:none;">0</span></a>';
      if(seeks){ ul.insertBefore(li, seeks.nextSibling); } else { ul.appendChild(li); }
    }
  }
  function applyHeaderCount(swat){
    swat.fetch(function(products){
      var c=products?products.length:0;
      var els=document.querySelectorAll('[data-swym-count]');
      for(var i=0;i<els.length;i++){ els[i].textContent=c; els[i].style.display=c>0?'':'none'; }
    });
  }
  function updateHeaderCount(swat){
    // Swym's fetch can return the pre-change list for a moment right after
    // an add, so re-apply a couple of times to catch the synced count.
    applyHeaderCount(swat);
    setTimeout(function(){ applyHeaderCount(swat); }, 900);
    setTimeout(function(){ applyHeaderCount(swat); }, 2200);
  }
  function makeBtn(cls){ var b=document.createElement('button'); b.type='button'; b.className=cls; b.setAttribute('aria-label','Add to wishlist'); b.innerHTML=FILL; return b; }
  function mark(btn,on){ btn.classList.toggle('gp-added',on); btn.setAttribute('aria-label',on?'Remove from wishlist':'Add to wishlist'); }

  function initPdpHeart(swat){
    var pd=window.SwymPageData; if(!pd||pd.et!==1) return;
    var container=document.querySelector('.product-image-container'); if(!container||container.querySelector('.gp-pdp-wishlist')) return;
    if(getComputedStyle(container).position==='static'){ container.style.position='relative'; }
    var btn=makeBtn('gp-pdp-wishlist'); container.appendChild(btn);
    var product={epi:pd.epi,empi:pd.empi,du:pd.du,dt:pd.dt,iu:pd.iu,pr:pd.pr};
    swat.fetch(function(wl){ mark(btn, wl.some(function(it){return it.empi===product.empi;})); });
    btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation();
      var was=btn.classList.contains('gp-added'); mark(btn,!was);
      if(was){ swat.removeFromWishList(product,function(){ updateHeaderCount(swat); },function(){ mark(btn,true); }); }
      else { swat.addToWishList(product,function(){ updateHeaderCount(swat); },function(){ mark(btn,false); }); } });
    if(swat.evtLayer && swat.JSEvents && swat.JSEvents.variantChanged){
      swat.evtLayer.addEventListener(swat.JSEvents.variantChanged,function(evt){
        var d=evt&&evt.detail&&evt.detail.d; var nv=d&&d.variant?d.variant.id:null;
        if(nv){ var vi=window.SwymProductVariants&&window.SwymProductVariants[nv]; product.epi=vi?vi.epi:nv; if(vi){product.pr=vi.pr; product.iu=vi.iu||product.iu;} }
        swat.fetch(function(wl){ mark(btn, wl.some(function(it){return it.empi===product.empi;})); }); }); }
  }

  function injectCardHearts(swat){
    var wraps=document.querySelectorAll(CARD_SELECTOR);
    for(var i=0;i<wraps.length;i++){
      var wrap=wraps[i]; if(wrap.querySelector('.gp-card-wishlist')) continue;
      var link=wrap.querySelector('a[href*="/products/"]'); if(!link) continue;
      var href=link.getAttribute('href'); if(!href) continue;
      var url=(href.indexOf('http')===0?href:location.origin+href).split('?')[0];
      var m=url.match(/\/products\/([^/?#]+)/); var handle=m?m[1]:''; if(!handle) continue;
      var pid=0; var qv=wrap.querySelector('[class*="quick-view-"]');
      if(qv){ var mm=qv.className.match(/quick-view-(\d+)/); if(mm) pid=Number(mm[1]); }
      if(getComputedStyle(wrap).position==='static'){ wrap.style.position='relative'; }
      var btn=makeBtn('gp-card-wishlist');
      if(pid && wishlistedSet[pid]) mark(btn,true);
      (function(btn,handle,url){
        btn.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation();
          var was=btn.classList.contains('gp-added'); mark(btn,!was);
          swat.getProductDetails({du:'/products/'+handle},function(pj){
            var p={empi:pj.empi||pj.id, epi:pj.epi||(pj.variants&&pj.variants[0]?pj.variants[0].id:0), du:url, dt:pj.dt||pj.title||'', iu:pj.iu||'', pr:pj.pr||0};
            if(was){ swat.removeFromWishList(p,function(){ delete wishlistedSet[p.empi]; updateHeaderCount(swat); },function(){ mark(btn,true); }); }
            else { swat.addToWishList(p,function(){ wishlistedSet[p.empi]=true; updateHeaderCount(swat); },function(){ mark(btn,false); }); }
          });
        });
      })(btn,handle,url);
      wrap.appendChild(btn);
    }
  }

  function buildEmpty(){
    var div=document.createElement('div'); div.className='gp-empty-wishlist';
    div.innerHTML='<div class="gp-empty-wishlist__inner">'+OUTLINE+'<h2>Your wishlist is empty</h2><p>Tap the heart on any piece you love and it will be saved here — we’ll even email you if it goes on sale.</p><a class="gp-empty-wishlist__btn" href="/collections/all-luxury-handbags">Continue Shopping</a></div>';
    return div;
  }
  function wishlistHost(){ return document.querySelector('.page__section-content .rte')||document.querySelector('.page__section-content')||document.getElementById('main-content'); }
  function showWishlistLoading(){
    if(!/\/pages\/wishlist/.test(location.pathname)) return;
    var host=wishlistHost(); if(!host||host.querySelector('.gp-wishlist-page')) return;
    var w=document.createElement('div'); w.className='gp-wishlist-page'; w.innerHTML='<div class="gp-wl-loading">Loading your wishlist…</div>'; host.appendChild(w);
  }
  function renderWishlistPage(swat){
    if(!/\/pages\/wishlist/.test(location.pathname)) return;
    var host=wishlistHost(); if(!host) return;
    swat.fetch(function(products){
      var old=host.querySelector('.gp-wishlist-page'); if(old) old.parentNode.removeChild(old);
      var wrap=document.createElement('div'); wrap.className='gp-wishlist-page';
      if(!products||products.length===0){ wrap.appendChild(buildEmpty()); host.appendChild(wrap); return; }
      var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'';
      var grid=document.createElement('div'); grid.className='gp-wl-grid';
      products.forEach(function(p){
        var card=document.createElement('div'); card.className='gp-wl-card';
        var title=(p.dt||'').replace(/</g,'&lt;');
        var priceHtml='';
        if(p.pr!=null && p.pr!==''){ var pf; try{ pf=cur?new Intl.NumberFormat(undefined,{style:'currency',currency:cur}).format(Number(p.pr)):(''+p.pr); }catch(e){ pf=''+p.pr; } priceHtml='<div class="gp-wl-price">'+pf+'</div>'; }
        card.innerHTML='<button class="gp-wl-remove" aria-label="Remove from wishlist" title="Remove">×</button>'+
          '<a class="gp-wl-img" href="'+p.du+'"><img src="'+(p.iu||'')+'" alt="'+title.replace(/"/g,'')+'" loading="lazy"></a>'+
          '<a class="gp-wl-title" href="'+p.du+'">'+title+'</a>'+priceHtml+
          '<a class="gp-wl-view" href="'+p.du+'">View</a>';
        card.querySelector('.gp-wl-remove').addEventListener('click',function(){
          card.style.opacity='0.4';
          swat.removeFromWishList({empi:p.empi,epi:p.epi,du:p.du},function(){ renderWishlistPage(swat); updateHeaderCount(swat); },function(){ card.style.opacity='1'; });
        });
        grid.appendChild(card);
      });
      wrap.appendChild(grid); host.appendChild(wrap);
    });
  }

  function onSwym(swat){
    injectHeaderHeart();
    try{ updateHeaderCount(swat); }catch(e){}
    try{ initPdpHeart(swat); }catch(e){}
    try{ renderWishlistPage(swat); }catch(e){}
    swat.fetch(function(wl){
      wishlistedSet={}; (wl||[]).forEach(function(it){ wishlistedSet[it.empi]=true; });
      injectCardHearts(swat);
      var main=document.getElementById('main-content');
      if(main && !main.__gpObs){ main.__gpObs=true; var t; var obs=new MutationObserver(function(){ clearTimeout(t); t=setTimeout(function(){ injectCardHearts(swat); },150); }); obs.observe(main,{childList:true,subtree:true}); }
    });
    if(swat.evtLayer){
      swat.evtLayer.addEventListener('sw:addedtowishlist',function(){ updateHeaderCount(swat); renderWishlistPage(swat); });
      swat.evtLayer.addEventListener('sw:removedfromwishlist',function(){ updateHeaderCount(swat); renderWishlistPage(swat); });
    }
  }
  function boot(){ injectHeaderHeart(); showWishlistLoading(); }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  window.SwymCallbacks=window.SwymCallbacks||[];
  window.SwymCallbacks.push(onSwym);
})();
